export const unionByKey = <T>(firstA: T[], secondA: T[], key: string): T[] => {
	const firstMap = firstA.reduce((acc, item) => {
		acc[item[key]] = item
		return acc
	}, {} as Record<string, T>)

	const secondMap = [
		...secondA.reduce((acc, i) => {
			if (!firstMap[i[key]]) {
				acc.add(i)
			}
			return acc
		}, new Set<T>()),
	] as T[]

	return [...firstA, ...secondMap] as T[]
}
